import { Model } from './model';

import { environment } from '../../environments/environment';

export class Quota extends Model {
  protected alertPercent = environment.cuotaAlertPercent;
  alert: boolean;

  year: string;
  amount: number;
  consumed: number;
  balance: number;
  real_amount: number;
  pending: number;
  gestcuota_adapted_amount: number;
  gestcuota_consumed: number;
  gestcuota_amount_available: number;

  constructor(values: Object = {}) {
    super(values);
  }

  protected calculateAlert() {
    const consumedPercent = (this.consumed * 100) / this.real_amount;
    return consumedPercent > this.alertPercent ? true : false;
  }

  public serialize() {
    const record = super.serialize();
    return record;
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/quota.ts